export const toUSCurrency = (value: number | undefined) => {
  return (value || 0).toLocaleString(
    'en-US', {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2
    });
}